import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
    clientAccountBasePath,
    clientSubAccountBasePath,
    clientSpecificReportBasePath,
    thoughtLeadershipResourceBasePath,
    clientAccPDBasePath,
    assignReferralBasePath,
    manageReferralBasePath,
    accountTeamMemberBasePath,
    meetingReqBasePath,
    clientUserBasePath,
    adminMsgBasePath,
    managePDBasePath,
    adminUserBasePath
} from "../../../routes/routePaths";
import { useDispatch } from "react-redux";
import { saveAdminUserSectionStaticContent } from "../../../redux/rtkSlices/sitecoreStaticContent/adminUserSectionStaticContentSlice";

const useCallSiteCoreContent = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    const { pathname } = location

    const regExp_adminUserBasePath = new RegExp(adminUserBasePath, 'i')
    const regExp_clientAccountBasePath = new RegExp(clientAccountBasePath, 'i')
    const regExp_clientSubAccountBasePath = new RegExp(clientSubAccountBasePath, 'i')
    const regExp_clientSpecificReportBasePath = new RegExp(clientSpecificReportBasePath, 'i')
    const regExp_thoughtLeadershipResourceBasePath = new RegExp(thoughtLeadershipResourceBasePath, 'i')
    const regExp_managePDBasePath = new RegExp(managePDBasePath, 'i')
    const regExp_clientAccPDBasePath = new RegExp(clientAccPDBasePath, 'i')
    const regExp_assignReferralBasePath = new RegExp(assignReferralBasePath, 'i')
    const regExp_manageReferralBasePath = new RegExp(manageReferralBasePath, 'i')
    const regExp_accountTeamMemberBasePath = new RegExp(accountTeamMemberBasePath, 'i')
    const regExp_meetingReqBasePath = new RegExp(meetingReqBasePath, 'i')
    const regExp_adminMsgBasePath = new RegExp(adminMsgBasePath, 'i')
    const regExp_clientUserBasePath = new RegExp(clientUserBasePath, 'i')


    /**add new sections here for new functionality */
    useEffect(() => {
        if (pathname?.search(regExp_adminUserBasePath) !== -1) {
            /** call sitecore API by passing specific key for route content and pass response values to redux slice state.  */

            /** right now passing empty paylaod to redux slice */
            const payload = {
                buttonLabels: {
                    adminUserView: "",
                    createButton: "",
                    updateButton: ""
                },
                titles: {
                    /**create page */
                    createNewAdminUser: "",
                    searchActiveUserDetails: "",
                    adminUserDetails: "",
                    adminUserRoles: "",
                    userProfileSection: "",
                    cronofySection: ""
                },
                fieldLabels: {
                    serach: {
                        searchEmailId: ""
                    },
                    adminUserDetails: {
                        firstName: "",
                        lastName: "",
                        email: "",
                        preferredName: "",
                        preferredNo: "",
                        AffiliatedEmail: "",
                        timezone: "",
                        country: "",
                        appLang: "",
                        serviceOff: "",
                        status: ""
                    },
                    adminUserRoles: {
                        enterpriseAdmin: "",
                        clientPortalRole: "",
                        candidatePortalRole: "",
                        country: "",
                        serviceOff: "",
                    },
                    userProfile: {
                        bio: "",
                        expertise: "",
                        linkedInId: "",
                        tweeterId: "",
                        lang: ""
                    },
                    cronofy: {
                        timezone: "",
                        serviceAccName: "",
                        availableDays: "",
                        workingStartHr: "",
                        workingEndHr: ""
                    }
                }
            }
            dispatch(saveAdminUserSectionStaticContent(payload))
        }
        else if (pathname?.search(regExp_clientAccountBasePath) !== -1) {

        }
        else if (pathname?.search(regExp_clientSubAccountBasePath) !== -1) {

        }

        else if (pathname?.search(regExp_clientUserBasePath) !== -1) {

        }

        else if (pathname?.search(regExp_clientSpecificReportBasePath) !== -1) {

        }

        else if (pathname?.search(regExp_thoughtLeadershipResourceBasePath) !== -1) {

        }

        else if (pathname?.search(regExp_managePDBasePath) !== -1) {

        }

        else if (pathname?.search(regExp_clientAccPDBasePath) !== -1) {

        }

        else if (pathname?.search(regExp_assignReferralBasePath) !== -1) {

        }

        else if (pathname?.search(regExp_manageReferralBasePath) !== -1) {

        }

        else if (pathname?.search(regExp_accountTeamMemberBasePath) !== -1) {

        }

        else if (pathname?.search(regExp_adminMsgBasePath) !== -1) {

        }

        else if (pathname?.search(regExp_meetingReqBasePath) !== -1) {

        }
    }, [pathname])
}
export default useCallSiteCoreContent